/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Process_Step2_DescInputs */

const et_process_step2_desc = /** @type {(inputs: Process_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saadame teile juhised, mis näitavad, kuidas saame teie profiilile turvalise juurdepääsu.`)
};

const en_process_step2_desc = /** @type {(inputs: Process_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll send you instructions showing how we get secure access to your profile.`)
};

/**
* | output |
* | --- |
* | "We'll send you instructions showing how we get secure access to your profile." |
*
* @param {Process_Step2_DescInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const process_step2_desc = /** @type {((inputs?: Process_Step2_DescInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Process_Step2_DescInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_process_step2_desc(inputs)
	return en_process_step2_desc(inputs)
});